import { z } from 'zod';
import { ClubHostPublicSchema } from './club-hosts.js';
import { ClubStatusSchema } from './clubs.js';

export const ReaderBlockSchema = z.object({
  id: z.string(),
  index: z.number(),
  type: z.string(),
  payload: z.record(z.unknown()),
  mediaUrl: z.string().nullable(),
  mediaMimeType: z.string().nullable().optional(),
  mediaProcessingStatus: z.enum(['ready', 'processing', 'failed']).nullable().optional(),
});

export type ReaderBlock = z.infer<typeof ReaderBlockSchema>;

export const ReaderChapterAccessSchema = z.enum(['demo', 'owned', 'locked']);
export type ReaderChapterAccess = z.infer<typeof ReaderChapterAccessSchema>;

export const ReaderChapterMetaSchema = z.object({
  id: z.string(),
  index: z.number(),
  title: z.string(),
  subtitle: z.string().nullable(),
  isDemo: z.boolean(),
  access: ReaderChapterAccessSchema,
});

export type ReaderChapterMeta = z.infer<typeof ReaderChapterMetaSchema>;

export const ReaderProgressSnapshotSchema = z.object({
  state: z.enum(['not_started', 'in_progress', 'completed']),
  scrollDepthMax: z.number(),
  activeTimeSeconds: z.number(),
  lastPosition: z.number().nullable(),
  exitReceivedAt: z.string().nullable(),
});

export type ReaderProgressSnapshot = z.infer<typeof ReaderProgressSnapshotSchema>;

export const ReaderMediaProgressItemSchema = z.object({
  blockId: z.string(),
  state: z.enum(['not_started', 'in_progress', 'completed']),
  positionSeconds: z.number(),
  manualCompleted: z.boolean(),
});

export type ReaderMediaProgressItem = z.infer<typeof ReaderMediaProgressItemSchema>;

export const ReaderBootstrapResponseSchema = z.object({
  club: z.object({
    id: z.string(),
    paywallSlug: z.string().nullable(),
    title: z.string(),
    status: ClubStatusSchema,
    coverUrl: z.string().nullable(),
    bookAuthor: z.string().nullable(),
    host: ClubHostPublicSchema,
    secondHost: ClubHostPublicSchema.nullable(),
    author: z.string().nullable(),
  }),
  chapters: z.array(ReaderChapterMetaSchema),
  chapter: z.object({
    id: z.string(),
    index: z.number(),
    title: z.string(),
    subtitle: z.string().nullable(),
    isDemo: z.boolean(),
    blocks: z.array(ReaderBlockSchema),
  }),
  access: z.enum(['demo', 'owned']),
  progressSnapshot: ReaderProgressSnapshotSchema.nullable(),
  mediaProgress: z.array(ReaderMediaProgressItemSchema),
});

export type ReaderBootstrapResponse = z.infer<typeof ReaderBootstrapResponseSchema>;
